import { CAT, MAS, RAT, REP_BLOCK, REP_SEC, SUB } from "../../Data/typeDirs"
import { genId } from "../../utils"
import { ReportNarrative } from "./reportNarrative"
import { ReportImage } from "./reportImage"
import { ReportRecommendation } from "./reportRecommendation"
import { mapChildArrayToObjects } from "./utils"



export class ReportBlock{

  constructor(data = {}){
    this._id = data._id || genId()
    this._reports_v2 = data._reports_v2
    this.created = data.created || Date.now()
    this._createdBy = data._createdBy 
    this.modified = data.modified
    this._modifiedBy = data._modifiedBy
    this.type = ReportBlock.getTypeDir()
    this.ratings = data.ratings 
    this.blockName = data.blockName || '(New Block)'
    this.subcategories = data.subcategories 
    this.categories = data.categories 
    this.mastercategories = data.mastercategories 
    this.report_sections = data.report_sections 
    this.narratives = data.narratives? new ReportNarrative(data.narratives) : ReportNarrative.createDefaultReportNarrative(this._reports_v2, this._id)
    this.recommendations = mapChildArrayToObjects(data.recommendations, ReportRecommendation)
    this.report_images = mapChildArrayToObjects(data.report_images, ReportImage).sort((a,b)=> ( a && a.orderIndex ? a.orderIndex < b.orderIndex ? -1 : 1 : a > b ? -1 :1 ))
    this.schema = data.schema || 'reportBlockSchema'
  }

  static createDefaultReportBlock(reportId, source){
    let subcategory = source[SUB][0]
    let category = source[CAT].find(cat=>cat._id === subcategory._categories)
    let mastercategory = source[MAS].find(mas=>mas._id === category._mastercategories)
    return new ReportBlock({
      _reports_v2:reportId,
      mastercategories:mastercategory._id,
      categories: category._id,
      subcategories: subcategory._id,
      report_sections:source[REP_SEC][0]._id,
      ratings:source[RAT][0]._id,
      blockName: `${subcategory.content} (New Block)`,
      schema:'reportBlockSchema'
    })
  }
  



  static getTypeDir() { return REP_BLOCK }
  static getIndices() { return '_id,_reports_v2' }


}